<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" @click.self="$emit('close')">
    <div class="bg-white rounded-lg p-6 max-w-3xl w-full max-h-[90vh] overflow-y-auto">
      <div class="flex justify-between items-start mb-4">
        <h2 class="text-xl font-bold">Call Details</h2>
        <button @click="$emit('close')" class="text-gray-500 hover:text-gray-700">
          <XMarkIcon class="w-6 h-6" />
        </button>
      </div>
      
      <div class="space-y-4">
        <div class="grid grid-cols-2 gap-4">
          <div>
            <span class="text-sm text-gray-500">Profile:</span>
            <span class="ml-2 font-medium">{{ call.profile?.name || 'Unknown' }}</span>
          </div>
          <div>
            <span class="text-sm text-gray-500">Duration:</span>
            <span class="ml-2">{{ formatDuration(call.duration) }}</span>
          </div>
          <div>
            <span class="text-sm text-gray-500">Date:</span>
            <span class="ml-2">{{ formatDate(call.created_at) }}</span>
          </div>
          <div>
            <span class="text-sm text-gray-500">Status:</span>
            <span :class="['ml-2 badge', getStatusClass(call.status)]">{{ call.status }}</span>
          </div>
        </div>
        
        <div v-if="call.transcript">
          <h3 class="font-semibold mb-2">Transcript</h3>
          <div class="bg-gray-50 p-4 rounded max-h-60 overflow-y-auto">
            <p class="text-sm">{{ call.transcript }}</p>
          </div>
        </div>
        
        <div v-if="call.summary">
          <h3 class="font-semibold mb-2">Summary</h3>
          <p class="text-gray-600">{{ call.summary }}</p>
        </div>
        
        <div class="flex justify-end">
          <button @click="$emit('close')" class="btn btn-secondary">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { XMarkIcon } from '@heroicons/vue/24/outline'
import dayjs from 'dayjs'

defineProps({
  call: {
    type: Object,
    required: true
  }
})

defineEmits(['close'])

function formatDuration(seconds) {
  if (!seconds) return 'N/A'
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  return `${mins}:${secs.toString().padStart(2, '0')}`
}

function formatDate(date) {
  return dayjs(date).format('MMM DD, YYYY h:mm A')
}

function getStatusClass(status) {
  const classes = {
    completed: 'badge-success',
    missed: 'badge-danger',
    in_progress: 'badge-warning'
  }
  return classes[status] || 'badge-secondary'
}
</script>